import React, { useState } from "react";
import { ThumbnailCarousel, ThumbnailCarouselProps } from "./ThumbnailCarousel";
import { ThumbnailCarouselItem } from "./ThumbnailCarouselItem";

import { PrintRecord } from "../../../../BlakeData";
import "./ItemsCarousel.d";
import ItemsCarousel from 'react-items-carousel';

import { ReactComponent as RightArrow } from "./arrow_right.svg";
import { ReactComponent as LeftArrow } from "./arrow_left.svg";


export const ReactItemsThumbnailCarousel: ThumbnailCarousel = (props: ThumbnailCarouselProps): JSX.Element => {

    const [activeItemIndex, setActiveItemIndex] = useState(0);

    const paletteWidth = 100;
    const chevronWidth = 30;
    const itemGutter = 50;
    const itemWidth = paletteWidth + itemGutter;

    const numberOfCards = Math.round((props.width || 1 * itemWidth) / itemWidth)


    if (props.prints.length < 2) { return <React.Fragment /> };

    // const pickItem = (n: number) => {
    //     const idx = props.selected.indexOf(n);
    //     let newSelected = props.selected;
    //     if (idx >= 0) {
    //         newSelected = newSelected
    //     } else {

    //     }
    //     props.onChange(newSelected);
    //     props.onChange([n].concat(props.selected).slice(0, 2))
    // }

    let items = props.prints.map((p: PrintRecord, i: number) => {

        const itemProps = {
            key: i,
            itemWidth: paletteWidth,
            print: p,
            onToggled: () => props.onToggleItem(i),
            selected: props.selected.indexOf(i) >= 0,
            index: i,
        }
        // const ret = ThumbnailCarouselItem(itemProps);
        const ret = <ThumbnailCarouselItem {...itemProps}/>
        return ret;

    })

    // let blankItem = () => <div className="blank carousel-item"></div>;
    // const fillerCardCount: number = Math.floor((numberOfCards - props.prints.length) / 2);
    // const blankItems = (new Array(fillerCardCount)).fill(blankItem())
    // items = blankItems.concat(items);

    const Arrow = (opts: { inner: JSX.Element, className: string }) => {
        return (
            <div
                className={opts.className}
            >{opts.inner}</div>
        );
    };

    const ArrowLeft = Arrow({ inner: (<LeftArrow/>), className: 'arrow-prev' });
    const ArrowRight = Arrow({ inner: (<RightArrow/>), className: 'arrow-next' });

    
    return (
        <div style={{ padding: `0 ${chevronWidth}px` }}
            className="ReactItemsPlateCarousel">
            <ItemsCarousel

                requestToChangeActive={setActiveItemIndex}
                activeItemIndex={activeItemIndex}
                infiniteLoop={false}
                //                gutter={10}
                activePosition={'center'}
                chevronWidth={chevronWidth}
                disableSwipe={false}
                alwaysShowChevrons={false}
                numberOfCards={Math.min(numberOfCards, items.length)}
                slidesToScroll={2}
                outsideChevron={true}
                showSlither={false}
                firstAndLastGutter={true}
                leftChevron={ArrowLeft}
                rightChevron={ArrowRight}

                classes={{
                    // wrapper: string, 
                    itemsWrapper: "items-wrapper", 
                    // itemsInnerWrapper: string, 
                    // itemWrapper: string, 
                    rightChevronWrapper: "chevron", 
                    leftChevronWrapper: "chevron" 
                }}
        >
                {items}
            </ItemsCarousel>
        </div >
    )



}
